import React from "react";

import { Avatar } from "@mui/material";
import { AvatarGroup as MuiAvatarGroup } from "@mui/lab";

const AvatarGroup = ({
  max = 5,
  members = [],
  avatarColor,
  memberColors,
  size = 28,
  spacing = "small"
}) => (
  <MuiAvatarGroup
    max={max}
    spacing={spacing}
    style={{ justifyContent: "flex-end" }}
  >
    {members.map((member, idx) => (
      <Avatar
        key={`avatar-group-element-${idx}`}
        style={{
          backgroundColor: memberColors ? memberColors[idx] : avatarColor,
          width: size,
          height: size,
          fontSize: size * 0.45
        }}
      >
        {member}
      </Avatar>
    ))}
  </MuiAvatarGroup>
);
export default AvatarGroup;
